import React from 'react';
import Modal from '@medflex/components/stories/Modal';
import { IconEditPencil } from '@medflex/components/stories/Icons';
import useLocationSearchParams from '@medflex/hooks/useLocationSearchParams';
import { useTranslation } from 'react-i18next';
import isSubContactId from '../../../utils/isSubContactId';
import ContactInfoModule from './ContactInfoModule';
import { MODALS } from '../../hooks/useIsModal';
import useModal from '../../hooks/useModal';

const ContactInfoModal = () => {
  const { t } = useTranslation('physician', { keyPrefix: 'ContactInfoModule' });
  const { userId, edit } = useLocationSearchParams();
  const { close, open } = useModal();
  const isContactInfoEditable = isSubContactId(userId);

  const closeModal = () => {
    close({ modal: MODALS.contact_info, userId, edit: true });
  };
  const handleEdit = () => {
    open({ modal: MODALS.contact_info, edit: true });
  };

  const handleCancelEdit = () => {
    open({ modal: MODALS.contact_info, edit: false });
  };

  const handleAfterSubmit = () => {
    open({ modal: MODALS.contact_info, edit: false });
  };

  return (
    <Modal
      showCloseButton
      onClickCloseButton={closeModal}
      title={t('title')}
      titleButton={
        isContactInfoEditable &&
        !edit && (
          <button
            type="button"
            className="focus:outline-none text-slate-500 hover:text-slate-600 flex items-center"
            onClick={handleEdit}
          >
            <IconEditPencil size="5" />
          </button>
        )
      }
    >
      <ContactInfoModule
        userId={userId}
        edit={edit === 'true'}
        handleEdit={handleEdit}
        handleCancelEdit={handleCancelEdit}
        handleAfterSubmit={handleAfterSubmit}
      />
    </Modal>
  );
};

export default ContactInfoModal;
